import gallery1 from "../../Images/gallery-1.png"
import gallery2 from "../../Images/gallery-2.png"
import gallery3 from "../../Images/gallery-3.png"
import gallery4 from "../../Images/gallery-4.png"
import gallery5 from "../../Images/gallery-5.png"
import gallery6 from "../../Images/gallery-6.png"
import gallery7 from "../../Images/gallery-7.png"
import gallery8 from "../../Images/gallery-8.png"
import gallery9 from "../../Images/gallery-9.png"
import gallery10 from "../../Images/gallery-10.png"
import gallery11 from "../../Images/gallery-11.png"
import gallery12 from "../../Images/gallery-12.png"
import gallery13 from "../../Images/gallery-13.png"
import gallery14 from "../../Images/gallery-14.png"
import gallery15 from "../../Images/gallery-15.png"
import search from "../../Images/search-icon.png";

export const GalleryData = [
    {
        id : 1 ,
        name : "Car Belt Replacement",
        img : gallery1,
        title : "Safety Device",
        icon : search,
        class : "gallery-content"
    },
    {
        id : 2,
        name : "Engine Oil Change",
        img : gallery2,
        title : "Engine",
        icon : search,
        class : "gallery-content gallery-two"
    },
    {
        id : 3,
        name : "Welding & Gas Cutting",
        img : gallery3,
        title : "Welding",
        icon : search,
        class : "gallery-content"
    },
    {
        id : 4,
        name : "Manual Greasing",
        img : gallery4,
        title : "Greasing",
        icon : search,
        class : "gallery-content gallery-four"
    },
    {
        id : 5,
        name : "Toll Box and Spanners",
        img : gallery5,
        title : "Tools",
        icon : search,
        class : "gallery-content gallery-five"
    },
    {
        id : 6,
        name : "Vehicle Lifting",
        img : gallery6,
        title : "Engine",
        icon : search,
        class : "gallery-content gallery-six"
    },
    {
        id : 7,
        name : "Vehicle Lifting",
        img : gallery7,
        title : "Lifting",
        icon : search,
        class : "gallery-content"
    },
    {
        id : 8,
        name : "Transmission Replacement",
        img : gallery8,
        title : "Transmission",
        icon : search,
        class : "gallery-content"
    },
    {
        id : 9,
        name : "Engine Oil Change",
        img : gallery9,
        title : "Engine",
        icon : search,
        class : "gallery-content"
    },
    {
        id : 10,
        name : "Bay Alligment",
        img : gallery10,
        title : "Bay",
        icon : search,
        class : "gallery-content"
    },
    {
        id : 11,
        name : "Engine Mounting chaecking",
        img : gallery11,
        title : "Engine",
        icon : search,
        class : "gallery-content"
    },
    {
        id : 12,
        name : "Tightness checking",
        img : gallery12,
        title : "Engine",
        icon : search,
        class : "gallery-content"
    },
    {
        id : 13,
        name : "Tyre replacement",
        img : gallery13,
        title : "tyre",
        icon : search,
        class : "gallery-content"
    },
    {
        id : 14,
        name : "Alternator belt replacement",
        img : gallery14,
        title : "Alternator",
        icon : search,
        class : "gallery-content"
    },
    {
        id : 15,
        name : "Vehicle Lifting",
        img : gallery15,
        title : "Lifting",
        icon : search,
        class : "gallery-content"
    },

]